import ListHotel from './ListHotel'
import * as rateActions from "../../../../../../actions/rateAction";
import * as homestayRateActions from "../../../../../../actions/homestayRateAction";
import { connect } from "react-redux";
import { withRouter } from "react-router";

const mapStateToProps = state => {
    return {
        rateState: state.rateReducer,
        homestayRateState: state.homestayRateReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRatesByHotels: (filters) => dispatch(rateActions.getListRatesByHotels(filters)),
        getListRatesByHomestays: (filters) => dispatch(homestayRateActions.getListHomestayRatesByHomestays(filters)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListHotel));
